import React from "react";
import "../../../Styles/Styles_estadisticas/sitiosInteres.css";

const SitiosInteres = () => {
  return (
    <section className="sitios-interes-compacto">
      <div className="sitios-container">
        <h3 className="sitios-title">sitio de interés</h3>
        <div className="sitios-logos">
          <a
            href="https://sigecro.umss.edu.bo/"
            target="_blank"
            rel="noopener noreferrer"
            className="sitio-item"
          >
            <img
              src="/sigecro.png"
              alt="SIGECRO"
              title="SIGECRO"
              className="sitio-logo"
            />
            <span className="sitio-nombre">SIGECRO</span>
          </a>

          <a
            href="https://samed-tsj.umss.edu.bo/"
            target="_blank"
            rel="noopener noreferrer"
            className="sitio-item"
          >
            <img
              src="/samed-tsj.png"
              alt="SAMED TSJ"
              title="SAMED TSJ"
              className="sitio-logo"
            />
            <span className="sitio-nombre">SAMED TSJ</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default SitiosInteres;
